// extracted by mini-css-extract-plugin
export var alignBaseline = "_1a-9";
export var alignCenter = "_1a-5";
export var alignFlexEnd = "_1a-7";
export var alignFlexStart = "_1a-6";
export var alignSelfBaseline = "_1a-e";
export var alignSelfCenter = "_1a-a";
export var alignSelfFlexEnd = "_1a-c";
export var alignSelfFlexStart = "_1a-b";
export var alignSelfStretch = "_1a-d";
export var alignStretch = "_1a-8";
export var column = "_1a-2";
export var columnReverse = "_1a-4";
export var flex = "_1a-0";
export var justifyCenter = "_1a-f";
export var justifyFlexEnd = "_1a-h";
export var justifyFlexStart = "_1a-g";
export var justifySpaceAround = "_1a-j";
export var justifySpaceBetween = "_1a-i";
export var justifySpaceEvenly = "_1a-k";
export var row = "_1a-1";
export var rowReverse = "_1a-3";
export var wrapNowrap = "_1a-m";
export var wrapWrap = "_1a-l";
export var wrapWrapReverse = "_1a-n";